<script lang="ts">
	import { CardGrid, Container, Icon, ProgressBar, Text } from '@Shelly/shelly-design-system/index';
	import type { PaypalInfoReturnValue } from 'src/types/Subscription';
	import { convertDatePayment } from 'src/helpers/date_helper';
	import { capFirstChar } from 'src/helpers/utilities';
	import { format } from 'svelte-i18n';

	export let paypalInfo: PaypalInfoReturnValue;
</script>

<CardGrid sm={300} lg={350} xl={425} noPaddingBottom>
	{#each paypalInfo.vouchersDates.filter((voucherDate) => voucherDate.status === 'used') as voucherDate}
		<div class="width-full lower-opacity">
			<Container padding="0" type="modalContainer">
				<div class="mt-m mb-m ml-m mr-m">
					<div class="d-flex justify-content-between align-items-center">
						<div class="d-flex align-items-center gap-s">
							<Icon size="s" icon="fas fa-ticket" class="icon-premium-color" />
							<Text styleType="body-small">{voucherDate.code}</Text>
						</div>
						<div class="d-flex align-items-center gap-xs">
							{#if voucherDate.status === 'used'}
								<Text class="text-bold" styleType="body-small" noWrap>
									{$format('label_expired_voucher', {
										default: 'Expired voucher',
									})}
								</Text>
							{:else if voucherDate.status === 'on_hold'}
								<Text class="text-bold" styleType="body-small" noWrap>
									{$format('label_on_hold', {
										default: 'On hold',
									})}
								</Text>
								<Icon size="s" icon="fas fa-circle-pause" />
							{:else}
								<Text class="text-success text-bold" styleType="body-small" noWrap>
									{capFirstChar(
										$format('active', {
											default: 'Active',
										}),
									)}
								</Text>
								<Icon size="s" icon="fas fa-circle-check text-success" />
							{/if}
						</div>
					</div>
					<ProgressBar class="width-full mt-s mb-s" progress={100} />
					<div class="d-flex justify-content-between align-items-center">
						<div class="d-flex align-items-center">
							<Text styleType="body-small" noWrap>
								{#if voucherDate.status === 'used'}
									{$format('label_expired', {
										default: 'Expired',
									})}
								{:else}
									{(voucherDate.status === 'on_hold' ? 0 : voucherDate.duration) -
										voucherDate.daysPassed}/{voucherDate.duration}
									{$format('text_premium_time_passed', {
										default: 'days',
									})}
								{/if}
							</Text>
						</div>
						<Text styleType="body-small" noWrap
							>{$format('label_until_date', {
								default: 'Until {endDate}',
								values: {
									endDate: convertDatePayment(voucherDate.end),
								},
							})}</Text
						>
					</div>
				</div>
			</Container>
		</div>
	{/each}
</CardGrid>

<style>
	.lower-opacity {
		opacity: 0.5;
	}
</style>
